__turbopack_context__.v({
  "bannerImage": "styles-module-scss-module__FFEsGa__bannerImage",
  "root": "styles-module-scss-module__FFEsGa__root",
});
